<shared-expanded-section class="loyalty-cta" [feel]="backgroundFeel">

    <shared-header *ngIf="title" [inverted]="headerInverted" [center]="true" type="2" marginTop="none" marginBottom="sm"
        class="loyalty-cta__title">
        {{title}}
    </shared-header>

    <div class="loyalty-cta__bd">
        <span class="loyalty-cta__line" *ngFor="let textLine of description">{{textLine}}</span>
    </div>
    <div class="loyalty-cta__ft">
        <shared-btn (onClick)="handleCreateAccountClick($event)" [inverted]="buttonInverted" [feel]="buttonFeel">
            Create Account
        </shared-btn>
    </div>
</shared-expanded-section>